import { Controller } from 'lib_ts/enums/routing/controllers';
import { DataCollectionsRoutes } from 'lib_ts/enums/routing/routes/data-collections';
import { IDataCollection } from 'lib_ts/interfaces/i-data-collection';
import { ICollectionShotGroup } from 'lib_ts/interfaces/training/i-machine-shot';
import { BaseRESTService } from 'services/_base-rest.service';

export class DataCollectionsService extends BaseRESTService {
  private static instance: DataCollectionsService;

  private static getInstance(): DataCollectionsService {
    if (!DataCollectionsService.instance) {
      DataCollectionsService.instance = new DataCollectionsService();
    }

    return DataCollectionsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.DataCollections,
    });
  }

  static async createOne(
    payload: Partial<IDataCollection>
  ): Promise<IDataCollection> {
    return await this.getInstance().post(
      {
        uri: DataCollectionsRoutes.CreateOne,
      },
      payload
    );
  }

  static async updateOne(
    id: string,
    payload: Partial<IDataCollection>
  ): Promise<IDataCollection> {
    return await this.getInstance().put(
      {
        uri: `${DataCollectionsRoutes.UpdateOne}/${id}`,
      },
      payload
    );
  }

  static async search(
    filter: Partial<IDataCollection>
  ): Promise<IDataCollection[]> {
    return await this.getInstance().post(
      {
        uri: DataCollectionsRoutes.Search,
      },
      filter
    );
  }

  static async getOne(id: string): Promise<IDataCollection> {
    return await this.getInstance().get({
      uri: `${DataCollectionsRoutes.GetOne}/${id}`,
    });
  }

  // filters based on exactly what is given in filter
  static async findLast(
    filter: Partial<IDataCollection>
  ): Promise<IDataCollection[]> {
    return await this.getInstance().post(
      {
        uri: DataCollectionsRoutes.FindLast,
      },
      filter
    );
  }

  // filters like findLast, but also excludes anything that is complete OR cancelled
  static async findLastInProgress(
    filter: Partial<IDataCollection>
  ): Promise<IDataCollection[]> {
    return await this.getInstance().post(
      {
        uri: DataCollectionsRoutes.FindLastInProgress,
      },
      filter
    );
  }

  // id = data-collections > _id
  static async getShotSummaries(
    id: string,
    matching_hash?: string
  ): Promise<ICollectionShotGroup[]> {
    return await this.getInstance().get({
      uri: `${DataCollectionsRoutes.ShotSummaries}/${id}`,
      params: {
        matching_hash: matching_hash ?? '',
      } as any,
    });
  }
}
